import axios from "axios";
import { API_BASE } from "../utils/api";

// Admin-only management of doctor accounts. All endpoints are IsAdminUser on
// the backend; auth is applied by the global axios interceptors.

export interface AdminDoctor {
  id: number;
  email: string;
  username: string;
  first_name: string;
  last_name: string;
  full_name: string;
  phone_number: string | null;
  doctor_id: number | null;
  specialization: string | null;
  is_active: boolean;
  is_staff: boolean;
  date_joined: string;
  last_login: string | null;
  /** Live Cognito state; null when Cognito could not be reached. */
  cognito_enabled: boolean | null;
  cognito_status: string | null;
}

const adminDoctorsService = {
  async listDoctors(): Promise<AdminDoctor[]> {
    const { data } = await axios.get<AdminDoctor[]>(`${API_BASE}/users/doctors/`);
    return data;
  },

  // Disable blocks sign-in (Cognito + Django) but preserves all records.
  async setActive(
    id: number,
    active: boolean,
  ): Promise<{ id: number; is_active: boolean; message: string }> {
    const { data } = await axios.post(`${API_BASE}/users/doctors/set-active/`, {
      id,
      active,
    });
    return data;
  },

  async deleteDoctor(id: number): Promise<{ message: string }> {
    const { data } = await axios.post(`${API_BASE}/users/doctors/delete/`, { id });
    return data;
  },
};

export default adminDoctorsService;
